import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { blue } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import image1 from "../../../../assets/advisory/iyadunni.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography variant={"subtitle2"} fontWeight={700}>
        Advisor
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Box
          width={{ xs: "100%", sm: "100%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#00AEEF"}
            paddingBottom={"1%"}
          >
            Iyadunni Olubode
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={{ xs: "50%", sm: "35%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.facebook.com/"
            title="Facebook"
          >
            <Avatar
              sx={{
                bgcolor: blue[900],
                width: 46,
                height: 46,
              }}
            >
              <FacebookIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.twitter.com/Iyadunnio1"
            title="Twitter"
          >
            <Avatar
              sx={{
                bgcolor: "#000",
                width: 46,
                height: 46,
              }}
            >
              <XIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.linkedin.com/in/iyadunni-olubode-a962736"
            title="LinkedIn"
          >
            <Avatar
              sx={{
                bgcolor: blue[700],
                width: 46,
                height: 46,
              }}
            >
              <LinkedInIcon />
            </Avatar>
          </Box>
        </Box>
      </Box>
      <Grid container marginTop={{ xs: "10%", sm: "2%" }}>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "3%" }}
          paddingTop={{ xs: "5%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "40vh", sm: "400px" }}
            paddingBottom={{ xs: "7%", sm: "0%" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              width: "100%",
            }}
            src={image1}
            alt={"about-image"}
          />
        </Grid>
        <Grid item xs={12} sm={4} paddingRight={{ xs: "0%", sm: "2%" }}>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
          >
            Iyadunni Olubode has over fifteen (15) years’ experience consulting
            with a global firm and managing one of the biggest non-profit
            organizations in Nigeria. She started her career with a commercial
            bank and subsequently moved to management consulting with Accenture
            where she cultivated expertise in Strategy and HR Consulting. She
            built strong skills in Project Management and Change Management; she
            transitioned to the development sector to pursue a passion for
            socio-economic change, starting with independent consulting
            engagements in the public and civil sectors which led to a full-time
            job managing one of Nigeria’s foremost indigenous non-profits.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            She is a strategic thinker, a skilled people manager and an
            energetic team player with exceptional communication skills and a
            strong work ethic; she is always thrilled about linking people with
            opportunities.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "2%" }}
          paddingTop={{ xs: "0.5%", sm: "0%" }}
        >
          <Typography variant="body1" color={"#4f4f4f"} paragraph>
            Iyadunni Olubode bagged a first degree in Economics from the
            prestigious University of Lagos and later proceeded to the
            University of Surrey, UK to obtain a Master’s Degree in Energy
            Economics and Policy. Iyadunni was formerly the Executive Director
            of LEAP Africa where she led the planning and delivery of annual
            projects to the highest quality and within budget, she developed and
            supervised a team of programme coordinators in designing and
            delivering youth and business programmes aimed at developing
            leadership capabilities.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            She also served as the Board Secretary coordinating the board
            affairs and managing relevant communications, raised funds and
            initiated partnerships to support the range of LEAP programmes and
            activities spanning youth and entrepreneurs with help from the Board
            and represented LEAP internationally and locally at several fora
            speaking on youth development, entrepreneurship and leadership
            themes.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details;
